
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 10.54 7.67","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.299.222a.75.75 0 00-1.065 0L3.646 5.817 1.3 3.462A.766.766 0 10.234 4.564l2.88 2.88a.75.75 0 001.065 0l6.12-6.12a.75.75 0 000-1.102z"}})])
          )
        }
      }
    